/* eslint-disable no-invalid-this */

import ApiService, { USERS_API_CONTEXT, USERS_API_HOST } from './ApiService';

/**
 * @override
 */
class PermissionService extends ApiService {
    /**
     * constructor
     */
    constructor() {
        super({ baseURL: USERS_API_HOST });
    }

    getPermissions = (sort, config) => {
        if (sort.trim() !== '') {
            return this.getList(`${USERS_API_CONTEXT}/permission-sets?$orderby=${sort}`, config);
        } else {
            return this.getList(`${USERS_API_CONTEXT}/permission-sets`, config);
        }
    };
    /**
     * Buscar permissions sets
     * @param {Array} search Búsqueda
     * @param {Object} config Axios config
     * @param {Object} sort Sort
     * @return {Object} Response with accounts
     */
    getSearch = (search, config, sort = false) => {
        const sortQueryParam = sort ? `&$orderby=${sort}` : '';
        return this.getList(`${USERS_API_CONTEXT}/permission-sets?$search=${search}${sortQueryParam}`, config);
    }
    getPermissionsObjects = config => {
        return this.get(`${USERS_API_CONTEXT}/permission-objects`, config);
    };
    getPermissionsActions = config => {
        return this.get(`${USERS_API_CONTEXT}/permission-actions`, config);
    };
    getPermissionByUUId = (uuid, config) => {
        return this.get(`${USERS_API_CONTEXT}/permission-sets/${uuid}`, config);
    }
    getPagination = (url, config) => this.get(`${url}`, config);
    /**
     * Actualizamos la información del permission set
     * @override
     */
    update = perms => {
        return this.put(`${USERS_API_CONTEXT}/permission-sets/${perms.uuid}`, perms);
    };
    /**
     * @override
     */
    create = perms => {
        return this.post(`${USERS_API_CONTEXT}/permission-sets`, perms);
    };

    /**
     * Delete permission
     * @param {String} uuid Permission id
     * @return {Object} Response of delete operation
     */
    deleteByUUIId = uuid => {
        return this.delete(`${USERS_API_CONTEXT}/permission-sets/${uuid}`, {});
    };

    /**
     * @override
     */
    download = (sort, config, headers) => {
        if (sort.trim() !== '') {
            return this.getDownload(`${USERS_API_CONTEXT}/permission-sets/download?$orderby=${sort}`, config, { headers });
        } else {
            return this.getDownload(`${USERS_API_CONTEXT}/permission-sets/download`, config, { headers });
        }
    };

}

const permissionService = new PermissionService();

export default permissionService;

